import { RuleProps } from 'types/application';

export const LICENCE_CATEGORY = 'licence-category';
export const FREQUENCY_ENTRY = 'frequency-entry';
export const STATION = 'station';
export const BASED_LAND_FIXED_STATION_INFORMATION = 'based-land-fixed-station-information';
export const OTHER_DETAILS = 'other-details';
export const STATION_ADDRESS = 'station-address';
export const LATITUDE = 'latitude';
export const LONGITUDE = 'longitude';
export const VENDOR_INFORMATION = 'vendor-information';
export const VENDOR_ADDRESS = 'vendor-address';
export const RADIO_EQUIPMENT_INFORMATION = 'radio-equipment-information';
export const ANTENNA_INFORMATION = 'antenna-information';
export const ANTENNA_DISPLACEMENT_FROM_STATION_LOCATION = 'antenna-displacement-from-station-location';
export const FILTER_INFORMATION = 'filter-information';
export const FEEDER_INFORMATION = 'feeder-information';
export const FREQUENCY_AND_EMISSION_CLASS_INFORMATION = 'frequency-and-emission-class-information';
export const SUPPORTING_DOCUMENTS = 'supporting-documents';

export const AMEND_TTF_APPLICATION = [
    {
        sectionID: LICENCE_CATEGORY,
        sectionName: '',
        fieldList: [
            {
                id: 'amend-table',
                label: ' ',
                type: 'table',
                subFields: [
                    {
                        id: 'type',
                        header: 'I want to amend',
                        type: 'text'
                    }
                ],
                span: 12
            },
            {
                id: 'licence-category',
                label: 'Licence Category',
                type: 'text',
                span: 12
            }
        ]
    },
    {
        sectionID: OTHER_DETAILS,
        sectionName: 'Other Details',
        fieldList: [
            {
                id: 'proposed-used-of-system',
                label: 'Proposed use of System/Equipment',
                type: 'text'
            },
            {
                id: 'remarks-by-applicant',
                label: 'Remarks by Applicant (Optional)',
                type: 'text'
            }
        ]
    },
    {
        sectionID: STATION,
        sectionName: '',
        fieldList: [
            {
                id: 'station-name',
                label: 'Station Name',
                type: 'select'
            },
            {
                id: 'total-number-of-stations',
                label: 'Total Number of Station(s)',
                type: 'text'
            }
        ]
    },
    {
        sectionID: BASED_LAND_FIXED_STATION_INFORMATION,
        sectionName: 'Base/Land Fixed Station Information',
        fieldList: [
            {
                id: 'call-sign',
                label: 'Call Sign (Optional)',
                type: 'text'
            },
            {
                id: 'station-name',
                label: 'Station Name',
                type: 'text'
            },
            {
                id: 'location-of-station',
                label: 'Location of Station (e.g. Rooftop)',
                type: 'text'
            },
            {
                id: 'date-of-comissioning',
                label: 'Date of Comissioning',
                type: 'text'
            }
        ]
    },
    {
        sectionID: STATION_ADDRESS,
        sectionName: 'Station Address',
        fieldList: [
            {
                id: 'building-name',
                label: 'Building Name',
                type: 'text'
            },
            {
                id: 'postal-code',
                label: 'Postal Code',
                type: 'text'
            },
            {
                id: 'street-name',
                label: 'Street Name',
                type: 'text'
            },
            {
                id: 'block-house-no',
                label: 'Block/House No.',
                type: 'text'
            },
            {
                id: 'floor-level',
                label: 'Floor/Level (Optional)',
                type: 'text'
            },
            {
                id: 'unit',
                label: 'Unit (Optional)',
                type: 'text'
            }
        ]
    },
    {
        sectionID: LATITUDE,
        sectionName: 'Latitude',
        fieldList: [
            {
                id: 'latitude-degrees',
                label: 'Latitude Degrees',
                type: 'text'
            },
            {
                id: 'latitude-minutes',
                label: 'Latitude Minutes',
                type: 'text'
            },
            {
                id: 'latitude-seconds',
                label: 'Latitude Seconds',
                type: 'text'
            }
        ]
    },
    {
        sectionID: LONGITUDE,
        sectionName: 'Longitude',
        fieldList: [
            {
                id: 'longitude-degrees',
                label: 'Longitude Degrees',
                type: 'text'
            },
            {
                id: 'longitude-minutes',
                label: 'Longitude Minutes',
                type: 'text'
            },
            {
                id: 'longitude-seconds',
                label: 'Longitude Seconds',
                type: 'text',
                span: 12
            },
            {
                id: 'building-height',
                label: 'Building Height (m)',
                type: 'text'
            },
            {
                id: 'station-antenna-effective-height',
                label: 'Station - Antenna Effective Height (m) (above ground level)',
                type: 'text'
            },
            {
                id: 'transportable',
                label: 'Transportable? (Optional)',
                type: 'text'
            },
            {
                id: 'station-antenna-elevation-angle',
                label: 'Station - Antenna Elevation Angle- with reference to horizontal plane (degree)',
                type: 'text'
            },
            {
                id: 'radius-of-operation',
                label: 'Radius Of Operation (km)',
                type: 'text'
            }
        ]
    },
    {
        sectionID: VENDOR_INFORMATION,
        sectionName: 'Vendor Information (if applicable)',
        fieldList: [
            {
                id: 'vendor-name',
                label: 'Vendor Name (Optional)',
                type: 'text'
            },
            {
                id: 'vendor-licence-number',
                label: 'Vendor Licence Number (Optional)',
                type: 'text'
            },
            {
                id: 'contact-person',
                label: 'Contact Person (Optional)',
                type: 'text'
            },
            {
                id: 'contact-number',
                label: 'Contact Number (Optional)',
                type: 'text'
            }
        ]
    },
    {
        sectionID: VENDOR_ADDRESS,
        sectionName: 'Address',
        fieldList: [
            {
                id: 'building-name',
                label: 'Building Name (Optional)',
                type: 'text'
            },
            {
                id: 'postal-code',
                label: 'Postal Code',
                type: 'text'
            },
            {
                id: 'street-name',
                label: 'Street Name',
                type: 'text'
            },
            {
                id: 'block-house-no',
                label: 'Block/House No.',
                type: 'text'
            },
            {
                id: 'floor-level',
                label: 'Floor/Level (Optional)',
                type: 'text'
            },
            {
                id: 'unit',
                label: 'Unit (Optional)',
                type: 'text'
            }
        ]
    },
    {
        sectionID: RADIO_EQUIPMENT_INFORMATION,
        sectionName: 'Radio Equipment Information',
        fieldList: [
            {
                id: 'manufacturer-transmitter',
                label: 'Manufacturer (Transmitter)',
                type: 'text'
            },
            {
                id: 'manufacturer-receiver',
                label: 'Manufacturer (Receiver)',
                type: 'text'
            },
            {
                id: 'model-transmitter',
                label: 'Model (Transmitter)',
                type: 'text'
            },
            {
                id: 'model-receiver',
                label: 'Model (Receiver)',
                type: 'text'
            },
            {
                id: 'output-power',
                label: 'Output Power (W) (Transmitter)',
                type: 'text'
            }
        ]
    },
    {
        sectionID: ANTENNA_INFORMATION,
        sectionName: 'Antenna Information',
        fieldList: [
            {
                id: 'antenna-manufacturer',
                label: 'Antenna Manufacturer',
                type: 'text'
            },
            {
                id: 'polarization',
                label: 'Polarization (Optional)',
                type: 'text'
            },
            {
                id: 'if-others-please-specify',
                label: 'If others, please specify',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${ANTENNA_INFORMATION}-polarization`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = !Boolean(baseValues && baseValues[`${ANTENNA_INFORMATION}-polarization`] === 'Others');
                        return result;
                    }
                }
            },
            {
                id: 'antenna-effective-height',
                label: 'Antenna Effective Height (m) (above ground level)',
                type: 'text'
            },
            {
                id: 'antenna-elevation-angle',
                label: 'Antenna Elevation Angle- with reference to horizontal plane (degree)',
                type: 'text'
            }
        ]
    },
    {
        sectionID: ANTENNA_DISPLACEMENT_FROM_STATION_LOCATION,
        sectionName: 'Antenna Displacement From Station Location',
        fieldList: [
            {
                id: 'north-latitude-displacement',
                label: 'North Latitude Displacement (Optional)',
                type: 'text'
            },
            {
                id: 'east-longitude-displacement',
                label: 'East Longitude Displacement (Optional)',
                type: 'text'
            },
            {
                id: 'gain-db',
                label: 'Gain (dB)',
                type: 'text'
            }
        ]
    },
    {
        sectionID: FILTER_INFORMATION,
        sectionName: 'Filter Information',
        fieldList: [
            {
                id: 'filter-manufacturer',
                label: 'Filter Manufacturer',
                type: 'text'
            },
            {
                id: 'model',
                label: 'Model',
                type: 'text'
            },
            {
                id: 'insertion-loss',
                label: 'Insertion Loss (dB)',
                type: 'text'
            },
            {
                id: 'tuned-frequency',
                label: 'Tuned Frequency (MHz)',
                type: 'text'
            }
        ]
    },
    {
        sectionID: FEEDER_INFORMATION,
        sectionName: 'Feeder Information',
        fieldList: [
            {
                id: 'feeder-line-type-transmit',
                label: 'Feeder Line Type (Transmit)',
                type: 'text'
            },
            {
                id: 'feeder-line-type-receive',
                label: 'Feeder Line Type (Receive)',
                type: 'text'
            },
            {
                id: 'feeder-line-length-transmit',
                label: 'Feeder Line Length(M)(Transmit)',
                type: 'text'
            },
            {
                id: 'feeder-line-length-receive',
                label: 'Feeder Line Length(M) (Receive)',
                type: 'text'
            },
            {
                id: 'feeder-line-loss-transmit',
                label: 'Feeder Line Loss(dB) (Transmit) (Optional)',
                type: 'text'
            },
            {
                id: 'feeder-line-loss-receive',
                label: 'Feeder Line Loss(dB) (Receive) (Optional)',
                type: 'text'
            }
        ]
    },
    {
        sectionID: FREQUENCY_AND_EMISSION_CLASS_INFORMATION,
        sectionName: 'Frequency and Emission Class Information',
        fieldList: [
            {
                id: 'frequency-and-emission-class-information-list',
                label: '',
                type: 'tableAccordion',
                span: 12,
                subFields: [
                    {
                        id: 'frequency-and-emission-class-info-table',
                        label: '',
                        type: 'table',
                        subFields: [
                            {
                                id: 'sn',
                                header: 'S/N',
                                type: 'text'
                            },
                            {
                                id: 'desired-frequency-mhz-from-tx',
                                header: 'Desired Frequency (MHz) - From (Tx)',
                                type: 'text'
                            },
                            {
                                id: 'desired-frequency-mhz-to-tx',
                                header: 'Desired Frequency (MHz) - To (Tx)',
                                type: 'text'
                            },
                            {
                                id: 'desired-frequency-mhz-from-rx',
                                header: 'Desired Frequency (MHz) - From (Rx)',
                                type: 'text'
                            },
                            {
                                id: 'desired-frequency-mhz-to-rx',
                                header: 'Desired Frequency (MHz) - To (Rx)',
                                type: 'text'
                            },
                            {
                                id: 'desired-bandwidth-khz-tx',
                                header: 'Bandwidth (kHz)(Tx)',
                                type: 'text'
                            },
                            {
                                id: 'desired-bandwidth-khz-rx',
                                header: 'Bandwidth (kHz)(Rx)',
                                type: 'text'
                            },
                            {
                                id: 'start-time',
                                header: 'Start Time',
                                type: 'text'
                            },
                            {
                                id: 'stop-time',
                                header: 'Stop Time',
                                type: 'text'
                            }
                        ]
                    },
                    {
                        id: 'frequency-and-emission-class-info-accordion',
                        label: '',
                        type: 'accordion',
                        subFields: [
                            {
                                id: 'emission-class-transmit',
                                label: 'Emission Class - Transmit',
                                type: 'text'
                            },
                            {
                                id: 'emission-class-receive',
                                label: 'Emission Class - Receive',
                                type: 'text'
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        sectionID: SUPPORTING_DOCUMENTS,
        sectionName: 'Supporting Documents',
        fieldList: [
            {
                id: 'supporting-documents',
                label: ' ',
                type: 'file',
                span: 12
            }
        ]
    }
];
